export const isUsageActivityLogUserDeleted = record =>
  record["usage_activity_logs.isUserDeleted"] === true ||
  record["usage_activity_logs.isUserDeleted"] === "true"
